module.exports = __webpack_public_path__ + "img/microsoft.622c630a.png";